import { PaywallError } from './PaywallError'

export class DuplicateBlockError extends PaywallError {
  constructor(type: string) {
    super(`Block with type ${type} is already registered`)
  }
}
